<template>
    <div class="news-topic">
        <!-- <newsHeader :page="'专题新闻'"></newsHeader> -->
        <breadCrumb></breadCrumb>
        <router-view></router-view>
        <scorllTop></scorllTop>
        <!-- <footer-view></footer-view> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            carouseHeight:'680',
            // ca:[[{id:1},{id:2},{id:3},{id:4}],[{id:5},{id:6},{id:7},{id:8}],[{id:9},{id:10},{id:11},{id:12}]],
            ca:[{id:1},{id:2},{id:3},{id:4},{id:5},{id:6},{id:7},{id:8},{id:9},{id:10},{id:11},{id:12}],
            carousel:[{
                page:[{
                imgURL:'',
                title:'【专题】抗击45263疫情，网络云课程3疫情，网络3疫情，网络3疫情，网络',
                describe:'7月17日，由宁在全国上下共同抗击新型冠在全国上下共同抗在全国上下共同抗在全国上下共同抗在全国上下共同抗状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
            },{
                imgURL:'',
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
            },{
                imgURL:'',
                title:'【专题】抗击242571网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
            },{
                imgURL:'',
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
            }]
            },{
                page:[{
                imgURL:'',
                title:'【专题242424242情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
            },{
                imgURL:'',
                title:'【专题】抗击475725络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
            },{
                imgURL:'',
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
            },{
                imgURL:'',
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
            }]
            },{
                page:[{
                imgURL:'',
                title:'【专题24242云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
            },{
                imgURL:'',
                title:'【专题】54752442，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
            },{
                imgURL:'',
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
            },{
                imgURL:'',
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
            }]
            },],
            lists:[{
                day:'25',
                month:'Apr',
                title:'【要点串烧】理论讲堂-教育信息化2.0教育教育',
                introduction:'技术的出现，改变了传统划重点、刷题的总结与复习模式，教师可以设计更全面、更丰富、更有效的总结与复习方案。今天云小桥介绍的三个工具：写得、UMU互动学习平台、小程序集，能助力教师更高效地开展总结与复习活动...',
                views:'1273'
            },{
                day:'25',
                month:'Apr',
                title:'【要点串烧】理论讲堂-教育信息化2.理论讲堂-教育信理论讲堂-教育信理论讲堂-教育信理论讲堂-教育信0教育教育',
                introduction:'技术的出现，改变了传统划重点、刷题的总结与复习模式，教师可以设计更全面、更丰富、更有效的总结与复习方案。今天云小桥介绍的三个工具：写得、UMU互动学习平台、小程序集，能助力教师更高效地开展总结与复习活动...',
                views:'1273'
            },{
                day:'25',
                month:'Apr',
                title:'【要点串烧】理论讲堂-教育信息化2.0教育教育',
                introduction:'技术的出现，改变了传统划重点、刷题的总结与复习模式，教师可以设计更全面、更丰富、更有效的总结与复习方案。今天云小桥介绍的三个工具：写得、UMU互动学习平台、小程序集，能助力教师更高效地开展总结与复习活动...',
                views:'1273'
            },{
                day:'25',
                month:'Apr',
                title:'【要点串烧】理论讲堂-教育信息化2.0教育教育',
                introduction:'技术的出现，改变了传统划重点、刷题的总结与复习模式，教师可以设计更全面、更丰富、更有效的总结与复习方案。今天云小桥介绍的三个工具：写得、UMU互动学习平台、小程序集，能助力教师更高效地开展总结与复习活动...',
                views:'1273'
            },{
                day:'25',
                month:'Apr',
                title:'【要点串烧】理论讲堂-教育信息化2.0教育教育',
                introduction:'技术的出现，改变了传统划重点、刷题的总结与复习模式，教师可以设计更全面、更丰富、更有效的总结与复习方案。今天云小桥介绍的三个工具：写得、UMU互动学习平台、小程序集，能助力教师更高效地开展总结与复习活动...',
                views:'1273'
            }]
        }
    },
    methods: {
         async getNewsList(){
            let that = this;
            let params = {
                clazz:3,
                // isAsc:desc,
                pageNum:1,
                pageSize: 7
            }            
            let resData = await Api.News.GetNewsList(params)
            // console.log(resData)
            that.lists = resData.rows;
            // this.schoolList = resData.rows
         },
         async getTopicList(){
            let params = {
                isAsc:'desc',
                pageNum:1,
                pageSize: 12
            }            
            let resData = await Api.News.GetTopicList(params)
            // console.log(resData);
            this.carousel = resData.rows
            let result = [];
            let res = [];
            for(let i = 0; i < resData.rows.length; i += 4) {
                result.push(resData.rows.slice(i,i+4))
            }
            this.carousel = result;

            // console.log( this.carousel )
         },

         handleTime(time,type){
             if(type === 'day') {
                return Common.handleTimeFour(time)
             } else if (type === 'month') {
                var month =  Common.handleTimeThree(time)
                month = Common.transformEnglish(month)
                return month
             }
         },
         toPage(id) {
             Common.goPage(`/news/topic/detail/${id}`,this)
         },
         toList(id) {
             Common.goPage(`/news/topic/list/${id}`,this)
         }
    },
    mounted(){
        this.getNewsList();
        this.getTopicList();
    }
}
</script>

<style lang="less" scoped>
    @import "../less/news_common.less";
    @import "../less/news_topic.less";
</style>